import get from 'lodash/get'
import * as Sentry from '@sentry/browser'

import { getHomeSellingInfo } from '../api/mikasa/requests'

import {
  FETCH_SHOULD_YOU_SELL_REQUEST,
  FETCH_SHOULD_YOU_SELL_SUCCESS,
  FETCH_SHOULD_YOU_SELL_FAILURE,
} from './actionTypes'

export const fetchHomeSellingInfo = homeId => async dispatch => {
  dispatch({
    type: FETCH_SHOULD_YOU_SELL_REQUEST,
  })

  try {
    const response = await getHomeSellingInfo(homeId)
    const appreciation = get(response, 'data.data.appreciation')
    const equityValue = get(response, 'data.data.equityValue')
    const cashPosition = get(response, 'data.data.cashPosition')

    dispatch({
      type: FETCH_SHOULD_YOU_SELL_SUCCESS,
      appreciation,
      equityValue,
      cashPosition,
    })
  } catch (error) {
    Sentry.captureException(error)
    dispatch({
      type: FETCH_SHOULD_YOU_SELL_FAILURE,
      error,
    })
  }
}
